import PrivacyPolicyContainer from 'core/userDeclaration/containers/PrivacyPolicyContainer'
import UserDeclarationContainer from 'core/userDeclaration/containers/UserDeclarationContainer'

const UserDeclarationLayer: React.FC = ({ children }) => {
  return (
    <>
      {children}
      <UserDeclarationContainer />
      <PrivacyPolicyContainer />
    </>
  )
}

export default UserDeclarationLayer
